<template>
	<div class="nav-bar">
		<div class="main-action" @click="onClickMainAction">
			<slot name="main-action">
				<img src="../../assets/img-v2/ic_nav_arrow.png" class="arrow-left" alt="返回">
			</slot>
		</div>
		<div class="title">
			<slot name="default">
			</slot>
		</div>
		<div class="more-action" v-if="hasMore" @click="onCLickMoreAction">
			<slot name="more-action">
			</slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'navBar',
	props: {
		hasMore: {
			type: Boolean,
			default: true
		},
		from: {
			type: Object
		},
    custom: {
      type: Boolean,
      default: false
    }
	},
	methods: {
		onClickMainAction() {
      if (this.custom) {
        this.$emit('click')
        return
      }
			try {
				if (this.from) {
					this.$router.replace(this.from);
				} else {
					if (window.history.length > 1) {
						this.$router.back();
					} else {
						this.$HomeService.turnToHomeView();
					}
				}
			} catch (err) {
				console.log('[登录页] 回跳失败，即将进入首页', err);
				this.$HomeService.turnToHomeView();
			}
		},
		onCLickMoreAction() {
			this.$emit('more');
		}
	}
};
</script>

<style scoped lang="scss">
	.nav-bar {
		width: 100%;
		height: auto;
		min-height: 52px;
		display: flex;
		flex-direction: row;
		align-items: center;
		text-align: center;
		border-bottom: 1px solid #f4f4f4;
		font-family: PingFangSC-Regular, PingFang SC;
		color: rgba(0, 0, 0, 0.87);
		background-color: #ffffff;
		position: sticky;
		top: 0;
		z-index: 100;
		.main-action {
			width: 44px;
			min-height: 40px;
			line-height: 40px;
			flex-shrink: 0;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;

			.arrow-left {
				width: 16px;
				height: 16px;
			}
		}
		.title {
			flex: 1;
			color: #000000;
			font-weight: 500;
			font-size: 16px;
			font-family: PingFangSC, PingFang SC;
		}
		.more-action {
			min-width: 52px;
		}
	}
</style>
